import store from "../store";
import dataLists from "../store/modules/dataLists";
import PGSHelper from "../helpers/PGSHelper.js";
import Currencies from "./Currencies.js";

export default class TicketVenta {
  
  constructor(data = null) {
    Object.assign(this, data);
    this.TextoTicket = ""
    this.TitleTicket = ""
    this.DirTicket = ""
    this.tenantTicket = localStorage.getItem("ParGolfTenant")
  }
  dataToTicketReprint() {
    this.setConfigTemplateTexts()
    this.setTicketConfig()
    if(this.isVenta){
      this.getCalcutateTotals()
    }else{
      this.getCalcutateTotalsDevolucion()
    }
    
    this.getCalculateIva()
    this.getDescuentos()
    this.getDescuentosTotal()
  }
  setConfigTemplateTexts(dataToTicket) {
    this.TextoTicket = this.Depto.Tickets?.TextoTicket;
    this.TitleTicket = this.Depto.Tickets?.TitleTicket;
    this.DirTicket = this.Depto.Tickets?.DirTicket;
  }
  setTicketConfig() {
    let ancho = "80 mm";
    this.ancho = {
      width: ancho,
    };
    this.showRealDollars = false
    if (localStorage.getItem("ParGolfTenant") == "TNTO") {
      this.showRealDollars = true
    }
    this.showDollar = true
    this.DescuentosDesglosados = false
    this.showDefualtTotal = true
  }
  getCalcutateTotals() {
    let montos = {
      TotalMxn: this.Total,
      TotalUsd: Number(this.Total / this.TC.USD),
      TotalRealUsd: Number(this.Total / this.TC.USD).toFixed(2),
      payPesos: 0,
      payDollar: 0,
      payDollarReal: 0
    };
    let pagos = (this.Pagos) ? Object.entries(this.Pagos) : [];
    pagos.forEach((element) => {
      let pesos = 0;
      let dolar = 0;
      if (element[1].Moneda == Currencies.getCurrencyDefault()) {

        pesos = element[1].Cantidad - ((this.Devos) ? this.Devos[element[0]] : 0);
        dolar = (element[1].Cantidad - ((this.Devos) ? this.Devos[element[0]] : 0)) / this.TC.USD;
      } else if (element[1].Moneda == "USD") {
        pesos = (element[1].Cantidad - ((this.Devos) ? this.Devos[element[0]] : 0)) * this.TC.USD;
        dolar = element[1].Cantidad - ((this.Devos) ? this.Devos[element[0]] : 0);
      }
      montos.payPesos = parseFloat(montos.payPesos) + parseFloat(pesos);
      montos.payDollar = Number(
        parseFloat(montos.payDollar) + parseFloat(dolar)
      );
      montos.payDollarReal = Number(
        parseFloat(montos.payDollarReal) + parseFloat(dolar)
      ).toFixed(2);
    });
    this.totales = montos;
  }
  getCalcutateTotalsDevolucion() {
    let montos = {
      TotalMxn: this.Total.C,
      TotalUsd: Math.ceil(this.Total.C / this.TC.USD),
      TotalRealUsd: Number(this.Total.C / this.TC.USD).toFixed(2),
      payPesos: 0,
      payDollar: 0,
      payDollarReal: 0
    };
    let pagos = (this.Pagos) ? Object.entries(this.Pagos) : [];
    pagos.forEach((element) => {
      let pesos = 0;
      let dolar = 0;
      if (element[1].Moneda == Currencies.getCurrencyDefault()) {

        pesos = element[1].Cantidad - ((this.Devos) ? this.Devos[element[0]] : 0);
        dolar = (element[1].Cantidad - ((this.Devos) ? this.Devos[element[0]] : 0)) / this.TC.USD;
      } else if (element[1].Moneda == "USD") {
        pesos = (element[1].Cantidad - ((this.Devos) ? this.Devos[element[0]] : 0)) * this.TC.USD;
        dolar = element[1].Cantidad - ((this.Devos) ? this.Devos[element[0]] : 0);
      }
      montos.payPesos = parseFloat(montos.payPesos) + parseFloat(pesos);
      montos.payDollar = Math.ceil(
        parseFloat(montos.payDollar) + parseFloat(dolar)
      );
      montos.payDollarReal = Number(
        parseFloat(montos.payDollarReal) + parseFloat(dolar)
      ).toFixed(2);
    });
    this.totales = montos;
  }
  getCalculateIva() {
    let totalIva = 0
    this.Catalogo.forEach((prod) => {
      let descuento = 0
      prod.Descuentos.forEach((desc) => {
        if (desc.Activo) {
          descuento += ((desc.Cnt) * desc.Cur.C)
        }
      })
      const useIvaRealtimeCalculate =  false
      if(useIvaRealtimeCalculate){
        if (prod.ivaPercent !== 0) {
          let iva = (prod.ivaPercent / 100);
          let total = Number(prod.TotalReal + (+Math.abs(descuento)))
          let subtotal = (total / (1+iva))
          let imp = Number((total - subtotal)).toFixed(2)
          totalIva += Number(imp)
        }
      }else{
        if (prod.Iva !== 0) {
          let iva = (prod.Iva / 100);
          let total = Number(prod.TotalReal + (+Math.abs(descuento)))
          console.log(total)
          let subtotal = (total / (1+iva))
          let imp = Number((total - subtotal)).toFixed(2)
          console.log("iva",imp,prod.TotalReal ,descuento)
          totalIva += Number(imp)
        }
      }
      
    })
    if (localStorage.getItem("ParGolfTenant") == 'PCUN') {
      this.IVA = Number(totalIva)
    } else {
      this.IVA = 0
    }
  }
  getDescuentos(){
    let $pgsHelper = new PGSHelper();
    let finalDescuentos = [];
      this.Catalogo.forEach((prod) => {
        prod.Descuentos.forEach((desc) => {

            let descuentoExist = $pgsHelper.getById(
              finalDescuentos,
              "Id",
              desc.Id
            );
            if (descuentoExist) {
              finalDescuentos[descuentoExist.idx].Total += desc.Cur.C;
            } else {
              finalDescuentos.push({
                Id: desc.Id,
                Nombre: desc.Dsc,
                Total: desc.Cur.C,
              });
            }
          
        });
      });
      this.totalDescuentos = finalDescuentos;
  }
  getDescuentosTotal(){
    let finalDescuentos = [];
      let totalDecuento = 0;
      let $pgsHelper = new PGSHelper();
      this.Catalogo.forEach((prod) => {
        prod.Descuentos.forEach((desc) => {
          if (desc.Activo) {
            let descuentoExist = $pgsHelper.getById(
              finalDescuentos,
              "Id",
              desc.Id
            );
            if (descuentoExist) {
              finalDescuentos[descuentoExist.idx].Total += ((desc.Cnt) * desc.Cur.C);
            } else {
              finalDescuentos.push({
                Id: desc.Id,
                Nombre: desc.Dsc,
                Total: (desc.Cnt * desc.Cur.C),
              });
            }
            totalDecuento += (desc.Cnt * desc.Cur.C);
          }
        });
      });
      this.totalDescontar = totalDecuento;
  }
}
